import { render } from "./pPE.vue?vue&type=template&id=6cf9fa6b"
import script from "./pPE.vue?vue&type=script&lang=js"
export * from "./pPE.vue?vue&type=script&lang=js"

import "./pPE.vue?vue&type=style&index=0&id=6cf9fa6b&lang=scss"

import exportComponent from "C:\\Users\\jekr\\Documents\\arla-foods-sc-event-platform\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__